<template>
  <div>
    <router-view />
    <WhatsAppWidget 
      phone-number="2349073016297"
      message="Hello! I'm interested in your services."
    />
  </div>
</template>
<script>
import WhatsAppButton from '@/components/WhatsAppButton.vue'
import WhatsAppWidget from '@/components/WhatsAppWidget.vue'
 export default{
   name:"App",
   computed:{
      getUser(){
        return this.$store.getters.getUser
      }
   },
  components: {
    WhatsAppButton,
    WhatsAppWidget
  }
 }
</script>
<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
